<template>
  <b-modal ref="trk-card-modal" @ok="trkCardModalOk">
    <template v-slot:modal-header="{}">
      <div>{{ $store.state.localization.data.mainPage.azk.trks.pageLabel }}</div>
    </template>
    <div style="font-size: 13px">
      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.trks.tableColumns.name"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="name"
          :state="isNameValid"
          style="font-size: 13px"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.trks.tableColumns.pointNameNtsMedoc"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="pointNameNtsMedoc"
          style="font-size: 13px"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.trks.tableColumns.driver"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="trk.driver"
          style="font-size: 13px"
          readonly
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.common.created"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="created"
          style="font-size: 13px"
          readonly
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.common.updated"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="updated"
          style="font-size: 13px"
          readonly
        ></b-form-input>
      </b-form-group>
      <b-form-group
          label-cols-sm="4"
          label-cols-lg="3"
          content-cols-sm
          content-cols-lg="8"
          :label="$store.state.localization.data.mainPage.azk.users.tableColumns.userName"
          label-for="input-horizontal"
        >
          <b-form-input
            v-model="trk.executor"
            style="font-size: 13px"
            readonly
          ></b-form-input>
      </b-form-group>
    </div>
    <template v-slot:modal-footer="{ ok, cancel }">
      <b-button variant="success" style="font-size: 12px" @click="ok()">{{
        $store.state.localization.data.common.table.ok
      }}</b-button>
      <b-button variant="light" style="font-size: 12px" @click="cancel()">{{
        $store.state.localization.data.common.table.cancel
      }}</b-button>
    </template>
  </b-modal>
</template>

<script>

import { utilsService, azkService } from "../../../../services";

export default {
  name: "UpdateTrkPage",
  props: {
    trk: Object,
    users: Array,
  },
  components: {},
  data() {
    return {
      name: null,
      pointNameNtsMedoc: null,

      isNameValid: null,
      created: null,
      updated: null
    };
  },
  methods: {
    async open() {
      this.name = this.trk.name;
      this.pointNameNtsMedoc = this.trk.pointNameNtsMedoc;

      this.isNameValid = null;

      this.created = utilsService.formatDateTime(new Date(this.trk.created * 1000), utilsService.DATE_TIME_FORMAT);
      this.updated = utilsService.formatDateTime(new Date(this.trk.updated * 1000), utilsService.DATE_TIME_FORMAT);

      this.$refs["trk-card-modal"].show();
    },
    async trkCardModalOk(event) {
      if (!this.name) {
        this.isNameValid = false;
        event.preventDefault();
        return;
      } else {
        this.isNameValid = null;
      }

      this.trk.name = this.name;
      this.trk.pointNameNtsMedoc = this.pointNameNtsMedoc;

      const updateTrkResponse = await azkService.updateTrk(this.trk);

      if (
        updateTrkResponse.isSuccess &&
        updateTrkResponse.data &&
        updateTrkResponse.data.countInsertedRows == 1
      ) {
        this.$emit("trkUpdatedSuccessEvent");
      } else {
        this.$emit("trkUpdatedFailEvent");
      }
    },
  },
};
</script>
